/**
 * useSubCasteEntryScreen.js
 * -------------------------
 * Hook for Sub-Caste create/edit form screen using shared useMasterEntry.
 */
import { useMasterEntry } from '../../common/useMasterEntry';
import * as subCasteApi from '../api/subCasteApi';

export function useSubCasteEntryScreen() {
  return useMasterEntry({
    entityName: 'Sub-Caste',
    apiClient: subCasteApi.subCasteClient,
    fetchDetail: subCasteApi.getSubCasteDetail,
    createItem: subCasteApi.createSubCaste,
    updateItem: subCasteApi.updateSubCaste,
    initialForm: {
      name: '',
    },
    validate: (form) => {
      if (!form.name || !form.name.trim()) {
        return 'Sub-Caste Name is required.';
      }
      return null;
    },
    listPath: '/masters/sub-caste/list',
  });
}
